import { useEffect, useState } from "react";
import axios from "axios";

export default function usePdfBlob({ endpoint, params = {}, enabled = true }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    let objectUrl = null;

    const fetchPdf = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}${endpoint}`,
          {
            params,
            responseType: "blob",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("api_token")}`,
            },
          },
        );

        const blob = new Blob([res.data], {
          type: "application/pdf",
        });

        objectUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(objectUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPdf();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [endpoint, JSON.stringify(params), enabled]);

  return { pdfBlobUrl, loading };
}
